import React from "react";
import { Box, Typography } from "@mui/material";
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyState = ({ message = "No data found" }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4, color: 'text.secondary' }}>
        <InboxIcon sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="body1">{message}</Typography>
    </Box>
);

export default EmptyState;
